// extracted by mini-css-extract-plugin
module.exports = {"container":"Crumb_container__GKvnB","active":"Crumb_active__pKmRW","arrow":"Crumb_arrow__VO_j_"};